"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectHomeListing = exports.homeListingBookmarkUpdated = exports.fetchHomeListingFailure = exports.fetchHomeListingSuccess = exports.fetchingHomeListing = exports.getHomeListing = exports.HOME_LISTING_CONFIG = exports.HOME_LISTING_SIZE = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var axios_1 = __importDefault(require("axios"));
exports.HOME_LISTING_SIZE = 6;
var firstPosts = function (posts) { return posts.slice(0, exports.HOME_LISTING_SIZE); };
// Each row is a plain search request; filter keys are the same ones the
// search page puts in its URL (config/schemas/filters).
exports.HOME_LISTING_CONFIG = {
    tours3d: {
        filters: { deal: 'sell', has_3D_tour: ['true'] },
        pick: firstPosts,
        // A different 6 of all 3D-tour listings on every page load.
        sortBy: 'random',
    },
    top: {
        // Search already puts paid pinned posts first; keep only those.
        filters: { deal: 'sell' },
        pick: function (posts) {
            return posts.filter(function (p) { return p.isPinToTop; }).slice(0, exports.HOME_LISTING_SIZE);
        },
    },
    developer: {
        filters: { deal: 'sell', is_developer: ['true'] },
        pick: firstPosts,
    },
    secondary: {
        filters: { deal: 'sell', is_developer: ['false'] },
        pick: firstPosts,
    },
};
var emptyRow = function () { return ({ posts: [], status: 'idle' }); };
var initialState = {
    tours3d: emptyRow(),
    top: emptyRow(),
    developer: emptyRow(),
    secondary: emptyRow(),
};
var homeListingsSlice = toolkit_1.createSlice({
    name: 'homeListings',
    initialState: initialState,
    reducers: {
        fetchingHomeListing: function (state, action) {
            state[action.payload].status = 'loading';
        },
        fetchHomeListingSuccess: function (state, action) {
            state[action.payload.key].status = 'succeeded';
            state[action.payload.key].posts = action.payload.posts;
        },
        fetchHomeListingFailure: function (state, action) {
            state[action.payload].status = 'failed';
        },
        // The same post can appear in several rows, so the heart is synced in all of them.
        homeListingBookmarkUpdated: function (state, action) {
            Object.values(state).forEach(function (row) {
                row.posts.forEach(function (post) {
                    if (post.id === action.payload.id) {
                        post.bookmarked = action.payload.bookmarked;
                    }
                });
            });
        },
    },
});
// A failed row is simply hidden on the page, so the error is not rethrown.
var getHomeListing = function (key) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, filters, pick, sortBy, data, rows, posts, e_1;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _a = exports.HOME_LISTING_CONFIG[key], filters = _a.filters, pick = _a.pick, sortBy = _a.sortBy;
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    dispatch(exports.fetchingHomeListing(key));
                    return [4 /*yield*/, axios_1.default.post('/api/search/filter-posts?page=1', { params: __assign({ filters: filters }, (sortBy && { sortBy: sortBy })) })];
                case 2:
                    data = (_d.sent()).data;
                    rows = (_c = (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.posts) === null || _c === void 0 ? void 0 : _c.data;
                    posts = Array.isArray(rows) ? pick(rows) : [];
                    dispatch(exports.fetchHomeListingSuccess({ key: key, posts: posts }));
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _d.sent();
                    dispatch(exports.fetchHomeListingFailure(key));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.getHomeListing = getHomeListing;
exports.fetchingHomeListing = (_a = homeListingsSlice.actions, _a.fetchingHomeListing), exports.fetchHomeListingSuccess = _a.fetchHomeListingSuccess, exports.fetchHomeListingFailure = _a.fetchHomeListingFailure, exports.homeListingBookmarkUpdated = _a.homeListingBookmarkUpdated;
var selectHomeListing = function (key) { return function (state) {
    return state.homeListings[key];
}; };
exports.selectHomeListing = selectHomeListing;
exports.default = homeListingsSlice.reducer;
